import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@/components/ui/skeleton";
interface Props {
  testId: string;
  count?: number;
  itemClassName?: string;
}
export function SearchSectionSkeleton(t0) {
  const $ = _c(8);
  const {
    testId,
    count: t1,
    itemClassName: t2
  } = t0;
  const count = t1 === undefined ? 3 : t1;
  const itemClassName = t2 === undefined ? "h-8 w-full" : t2;
  let t3;
  if ($[0] !== count) {
    t3 = Array.from({
      length: count
    }, _temp);
    $[0] = count;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const keys = t3;
  let t4;
  if ($[2] !== itemClassName || $[3] !== keys) {
    t4 = keys.map(key => <Skeleton key={key} className={itemClassName} />);
    $[2] = itemClassName;
    $[3] = keys;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4 || $[6] !== testId) {
    t5 = <div className="flex flex-col gap-2" data-testid={testId}>{t4}</div>;
    $[5] = t4;
    $[6] = testId;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
function _temp(_, index) {
  return index;
}